export const DisplayTitle = ({ productType, anchorFirstName }) => {
  if (productType === 'FANCLUB') {
    if (anchorFirstName) {
      return `You now have premium access to ${anchorFirstName}'s Fan Zone!`;
    }

    return 'You now have premium access to Naked News Live!';
  }

  return 'Welcome to Naked News!';
};

export const DisplayText = ({ productType, renewal }) => {
  if (renewal && productType === 'FANCLUB') {
    return 'Your new subscription has been added.';
  }

  return `We've emailed you a receipt of your subscription purchase.
    Additionally, you can always check the status of subscription in your Account Settings.`;
};
